import { Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { toast } from "sonner";
import { useAuth } from "../contexts/AuthContext";
import { hasPermission, isDriverOnly } from "../lib/permissions";

/**
 * Route gate.
 * - Not logged in        → /welcome
 * - Kierowca-only user   → /kierowca (their portal home is just a QR-download screen)
 * - adminOnly + non-admin → /
 * - perm prop set + user lacks it → / (with a toast explaining why)
 */
export default function ProtectedRoute({ children, adminOnly = false, perm = null, allowDriver = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  const blocked = user && !loading && (
    (!allowDriver && isDriverOnly(user)) ||
    (adminOnly && user.role !== "admin") ||
    (perm && !hasPermission(user, perm))
  );

  useEffect(() => {
    if (blocked) {
      toast.error("Nie masz uprawnień do tej funkcji. Skontaktuj się z administratorem.");
    }
  }, [blocked]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="w-10 h-10 border-4 border-zinc-200 border-t-brand rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/welcome" replace state={{ from: location }} />;
  }
  if (!allowDriver && isDriverOnly(user)) {
    return <Navigate to="/kierowca" replace />;
  }
  if (adminOnly && user.role !== "admin") {
    return <Navigate to="/" replace />;
  }
  if (perm && !hasPermission(user, perm)) {
    return <Navigate to="/" replace />;
  }
  return children;
}
